/**
 * 商品詳細ページの商品写真エリア
 */
export default class ProductImage extends HTMLElement {
  constructor() {
    super();

    // 各種変数の初期化
    this.slideNum;
    
    this.productSlider();
  }
  
  /**
   * メイン画像スライダーの設定
   */
  mainSwiper = new Swiper(".unico-product-image-list", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 0,
    breakpoints: {
      769: {
        loop: true,
        paginationClickable: true,
        navigation: {
          nextEl: '.unico-product-image-list .unico-m-nav-arrow.-type-next',
          prevEl: '.unico-product-image-list .unico-m-nav-arrow.-type-prev',
        },
      }
    }
  });

  
  /**
   * サムネイルスライダーの設定
   */
  thumbSwiper = new Swiper(".unico-product-thumb-list", {
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 8,
    speed: 0,
    scrollbar: {
      el: '.unico-product-thumb-list .swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      769: {
        loop: true,
        spaceBetween: 0,
        scrollbar: false
      }
    }
  });

  
  /**
   * コメントスライダーの設定
   */
  commentSwiper = new Swiper(".unico-product-comment-list", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 0,
    thumbs: {
      swiper: this.thumbSwiper,
    },
    breakpoints: {
      769: {
        loop: true,
      }
    }
  });

  
  /**
   * 連動スライダーの設定
   */
  productSlider() {
    // メイン画像を基準にサムネイルとコメントを連動
    this.mainSwiper.on('slideChangeTransitionEnd', (slider) => {
      this.slideNum = slider.realIndex;
      this.commentSwiper.slideToLoop(this.slideNum, undefined, false);
    });
  
    // コメントを基準にメイン画像とサムネイルを連動
    this.commentSwiper.on('slideChangeTransitionEnd', (slider) => {
      this.slideNum = slider.realIndex;
      this.mainSwiper.slideToLoop(this.slideNum, undefined, false);
    });
  }
}
